import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';

const NewsFeed = ({ market, timeframe }) => {
  const [selectedCategory, setSelectedCategory] = useState('all');
  const [savedArticles, setSavedArticles] = useState([]);

  const categories = [
  { id: 'all', label: 'All News', icon: 'Newspaper' },
  { id: 'breaking', label: 'Breaking', icon: 'Zap' },
  { id: 'policy', label: 'Policy Updates', icon: 'FileText' },
  { id: 'market', label: 'Market Trends', icon: 'TrendingUp' },
  { id: 'export', label: 'Export News', icon: 'Globe' }];


  const mockNews = [
  {
    id: 1,
    title: 'Sugar Export Quota Increased by 15% for Q4 2025',
    source: 'Trade Ministry Official',
    category: 'policy',
    impact: 'high',
    timestamp: '2 hours ago',
    summary: 'The government announces a significant increase in sugar export quota, expected to benefit major producing states including Maharashtra and UP.',
    image: {
      url: "https://img.rocket.new/generatedImages/rocket_gen_img_1e088f9c7-1772541951004.png",
      alt: 'Industrial sugar production facility with stainless steel processing equipment and white refined sugar'
    },
    verified: true,
    region: 'National',
    readTime: '3 min read'
  },
  {
    id: 2,
    title: 'Maharashtra Sugar Mills Report Record Production This Season',
    source: 'State Sugar Federation',
    category: 'market',
    impact: 'medium',
    timestamp: '5 hours ago',
    summary: 'Record-breaking sugarcane crushing and sugar production reported across Maharashtra mills, driving market prices down by 2%.',
    image: {
      url: "https://images.unsplash.com/photo-1632289432111-0e2519584350",
      alt: 'Sugarcane field with tall green crops under blue sky ready for harvest season'
    },
    verified: true,
    region: 'Maharashtra',
    readTime: '4 min read'
  },
  {
    id: 3,
    title: 'International Sugar Prices Hit 5-Year High Amid Supply Concerns',
    source: 'Global Commodities Report',
    category: 'breaking',
    impact: 'high',
    timestamp: '1 hour ago',
    summary: 'Global sugar prices surge due to weather disruptions in Brazil and increased demand from Asian markets.',
    image: {
      url: "https://img.rocket.new/generatedImages/rocket_gen_img_180265dda-1772070465313.png",
      alt: 'Global shipping containers at international port dock with crane operations for commodity trade'
    },
    verified: true,
    region: 'International',
    readTime: '5 min read'
  },
  {
    id: 4,
    title: 'New Ethanol Blending Policy to Impact Sugar Industry Dynamics',
    source: 'Energy Department',
    category: 'policy',
    impact: 'high',
    timestamp: '8 hours ago',
    summary: 'Government mandates 20% ethanol blending by 2025, creating new revenue streams for sugar mills.',
    image: {
      url: "https://img.rocket.new/generatedImages/rocket_gen_img_105747df9-1774614331769.png",
      alt: 'Modern biofuel production plant with ethanol distillation towers and storage tanks'
    },
    verified: true,
    region: 'National',
    readTime: '6 min read'
  },
  {
    id: 5,
    title: 'Karnataka Mills Adopt AI-Powered Quality Control Systems',
    source: 'Tech Agriculture News',
    category: 'market',
    impact: 'medium',
    timestamp: '12 hours ago',
    summary: 'Leading sugar mills in Karnataka implement advanced AI systems for quality monitoring and process optimization.',
    image: {
      url: "https://img.rocket.new/generatedImages/rocket_gen_img_1e5e198fc-1773877439944.png",
      alt: 'Advanced industrial control room with digital screens monitoring automated sugar production processes'
    },
    verified: true,
    region: 'Karnataka',
    readTime: '4 min read'
  },
  {
    id: 6,
    title: 'UP Government Announces ₹500 Crore Support Package for Mills',
    source: 'State Agriculture Ministry',
    category: 'policy',
    impact: 'high',
    timestamp: '6 hours ago',
    summary: 'Special financial package announced to help sugar mills clear pending farmer dues and modernize facilities.',
    image: {
      url: "https://img.rocket.new/generatedImages/rocket_gen_img_1f5c98567-1772092670365.png",
      alt: 'Financial planning meeting with documents, calculator and laptop showing budget allocations'
    },
    verified: true,
    region: 'Uttar Pradesh',
    readTime: '5 min read'
  }];


  const filteredNews = mockNews?.filter((news) => {
    if (selectedCategory !== 'all' && news?.category !== selectedCategory) return false;
    if (market !== 'all' && !news?.region?.toLowerCase()?.includes(market?.replace('-', ' '))) return false;
    return true;
  });

  const handleSaveArticle = (articleId) => {
    if (savedArticles?.includes(articleId)) {
      setSavedArticles(savedArticles?.filter((id) => id !== articleId));
    } else {
      setSavedArticles([...savedArticles, articleId]);
    }
  };

  const getImpactBadgeColor = (impact) => {
    switch (impact) {
      case 'high':
        return 'bg-red-100 text-red-700 border-red-200';
      case 'medium':
        return 'bg-orange-100 text-orange-700 border-orange-200';
      case 'low':
        return 'bg-blue-100 text-blue-700 border-blue-200';
      default:
        return 'bg-gray-100 text-gray-700 border-gray-200';
    }
  };

  return (
    <div className="space-y-6">
      {/* Sample content disclosure */}
      <div className="flex items-center gap-2 px-4 py-2.5 rounded-lg bg-amber-50 border border-amber-200">
        <Icon name="Info" size={16} className="text-amber-600 flex-shrink-0" />
        <p className="text-xs text-amber-700 font-medium">
          Sample content — shown for illustration only. This is not live news or verified market information.
        </p>
      </div>

      {/* Category Filter */}
      <div className="flex items-center gap-3 overflow-x-auto pb-2">
        {categories?.map((category) =>
        <button
          key={category?.id}
          onClick={() => setSelectedCategory(category?.id)}
          className={`flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-medium whitespace-nowrap transition-colors ${
          selectedCategory === category?.id ?
          'bg-primary text-white' : 'bg-muted text-muted-foreground hover:bg-muted/80'}`
          }>

            <Icon name={category?.icon} size={16} />
            <span>{category?.label}</span>
          </button>
        )}
      </div>

      {/* News Cards */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        {filteredNews?.map((news) =>
        <div
          key={news?.id}
          className="bg-card border border-border rounded-lg overflow-hidden hover:shadow-lg transition-shadow">

            <div className="relative">
              <img
              src={news?.image?.url}
              alt={news?.image?.alt}
              className="w-full h-48 object-cover" />

              {news?.verified &&
            <div className="absolute top-3 right-3 bg-green-500 text-white px-2 py-1 rounded-full flex items-center gap-1 text-xs font-medium">
                  <Icon name="CheckCircle" size={12} />
                  <span>Verified</span>
                </div>
            }
            </div>

            <div className="p-5 space-y-4">
              <div className="flex items-start justify-between gap-3">
                <div className="flex-1">
                  <div className="flex items-center gap-2 mb-2">
                    <span className={`px-2 py-1 rounded text-xs font-medium border ${getImpactBadgeColor(news?.impact)}`}>
                      {news?.impact?.toUpperCase()} IMPACT
                    </span>
                    <span className="text-xs text-muted-foreground">{news?.region}</span>
                  </div>
                  <h3 className="text-lg font-bold text-foreground mb-2 line-clamp-2">
                    {news?.title}
                  </h3>
                </div>
                
                <button
                onClick={() => handleSaveArticle(news?.id)}
                className="flex-shrink-0 p-2 rounded-full hover:bg-muted transition-colors">

                  <Icon
                  name={savedArticles?.includes(news?.id) ? 'BookmarkCheck' : 'Bookmark'}
                  size={20}
                  className={savedArticles?.includes(news?.id) ? 'text-primary fill-primary' : 'text-muted-foreground'} />

                </button>
              </div>

              <p className="text-sm text-muted-foreground line-clamp-3">
                {news?.summary}
              </p>

              <div className="flex items-center justify-between pt-3 border-t border-border">
                <div className="flex items-center gap-4 text-xs text-muted-foreground">
                  <div className="flex items-center gap-1">
                    <Icon name="Clock" size={14} />
                    <span>{news?.timestamp}</span>
                  </div>
                  <div className="flex items-center gap-1">
                    <Icon name="BookOpen" size={14} />
                    <span>{news?.readTime}</span>
                  </div>
                </div>

                <button className="flex items-center gap-2 text-sm font-medium text-primary hover:text-primary/80 transition-colors">
                  <span>Read More</span>
                  <Icon name="ArrowRight" size={16} />
                </button>
              </div>

              <div className="flex items-center gap-2 text-xs text-muted-foreground pt-2">
                <Icon name="Newspaper" size={14} />
                <span>{news?.source}</span>
              </div>
            </div>
          </div>
        )}
      </div>

      {filteredNews?.length === 0 &&
      <div className="text-center py-12 bg-card border border-border rounded-lg">
          <Icon name="Search" size={48} className="mx-auto text-muted-foreground mb-4" />
          <h3 className="text-lg font-semibold text-foreground mb-2">No News Found</h3>
          <p className="text-muted-foreground">
            Try adjusting your filters to see more results
          </p>
        </div>
      }
    </div>);

};

export default NewsFeed;